import React from "react";
import { withNavBars } from "../../HOCs";
import UtilityMaster from "./utilityMaster";

class UtilityMasterParent extends React.Component {
  render() {
    return <UtilityMaster {...this.props} />;
  }
}

const props = {
  boxShadow: false
}

export default withNavBars(UtilityMasterParent, props);
